import { render, staticRenderFns } from "./RosterStatusTypeEdit.vue?vue&type=template&id=770c31ea&scoped=true&"
import script from "./RosterStatusTypeEdit.vue?vue&type=script&lang=js&"
export * from "./RosterStatusTypeEdit.vue?vue&type=script&lang=js&"
import style0 from "./RosterStatusTypeEdit.vue?vue&type=style&index=0&id=770c31ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770c31ea",
  null
  
)

export default component.exports